import { termosStep } from '../../shared/termosSections';

const pedidoEnvioTermoPosseConfig = {
  id: 'pedido_envio_termo_posse',
  nome: 'Pedido de Envio do Termo de Posse',
  categoria: 'pedidos',
  descricao: 'Envio do Termo de Posse para comprovação do motivo do licenciamento',
  icon: 'FaFileSignature',

  documentConfig: {
    required: [
      {
        id: 'termoPosse', tipoDocumentoProcesso: 378,
        name: 'Termo de Posse',
        description: 'Documento essencial para a comprovação do motivo do licenciamento',
        required: true
      }
    ]
  },

  paymentConfig: {
    amount: 0
  },

  protocoloConfig: {
    modeloRequerimento: '309',
    tiposAssunto: '550',
    tipoPedido: '497'
  },

  dadosRequerimentoConfig: {
    campos: [
      { field: 'nomeCompleto', campoNome: 'Nome' },
      { field: 'cpf', campoNome: 'CPFCNPJ' },
      { field: 'numeroRequerimentoLicenciamento', campoNome: 'Observacao' }
    ]
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { type: 'text', name: 'nomeCompleto', label: 'Nome completo', required: true, placeholder: 'Digite seu nome completo' },
            { type: 'cpf', name: 'cpf', label: 'CPF', required: true },
            { type: 'text', name: 'numeroRequerimentoLicenciamento', label: 'Número do Requerimento do Pedido de Licenciamento', required: true, placeholder: 'Nº do requerimento' }
          ]
        }
      ]
    },
    termosStep()
  ]
};

export default pedidoEnvioTermoPosseConfig;
